module.exports = __webpack_public_path__ + "img/EDC8000_R.0acf51c4.png";